// image = 0,
// audio = 1,
// video = 2,
// pdf = 3,
// xlsx = 4,
// word = 5,

export const STEP_CONTENT_TYPE = [
  { label: 'اسلایدر', value: 0 },
  { label: 'صدا', value: 1 },
  { label: 'ویدیو', value: 2 },
  { label: 'متن (HTML)', value: 3 },
];

export const STEP_FILE_TYPE = [
  { label: 'PDF', type: 3, accept: '.pdf' },
  { label: 'Excel', type: 4, accept: '.xlsx' },
  { label: 'Word', type: 5, accept: '.docs, .docx' },
  { label: 'Image', type: 0, accept: 'image/*' },
  { label: 'Video', type: 2, accept: 'video/*' },
];
